import type {
  PctHttpErrorResponse,
  TransformHttpErrorToPtHttpErrorResponseFn,
} from '@pct-ng/core/error-http';
import { BackendErrorWithMessageError, FieldError } from '@pct-ng/core/error-http';
import { map, Observable, of } from 'rxjs';
import {
  type BackendErrorWithMessage,
  isBackendErrorWithMessage,
} from './typeguard/is-backend-error-with-message';
import { login } from '../../../frontend/user/login';

export const transformHttpErrorToPctHttpErrorResponse: TransformHttpErrorToPtHttpErrorResponseFn = (
  error: PctHttpErrorResponse,
): Observable<PctHttpErrorResponse> => {
  if (![400, 401, 403, 404, 409].includes(error.status)) {
    return of(error);
  }
  // Handle 401
  if (error.status === 401) {
    return login().pipe(map(() => error));
  }

  // Handle error types
  const { message, status, headers, response } = error;

  return new Observable<string>((observer: any) => {
    const reader = new FileReader();
    reader.onload = event => {
      observer.next((event.target as any).result);
      observer.complete();
    };
    reader.readAsText(response);
  }).pipe(
    map(responseString => {
      let backendErrors: any;
      try {
        backendErrors = JSON.parse(responseString);
        // eslint-disable-next-line sonarjs/no-ignored-exceptions
      } catch (_e: any) {
        return error;
      }
      if (isBackendErrorWithMessage(backendErrors)) {
        const { errors } = backendErrors;
        if (errors.length === 1 && errors[0].field === 'unknown') {
          return new BackendErrorWithMessageError<BackendErrorWithMessage>(
            backendErrors,
            message,
            status,
            response,
            headers,
          );
        }
        return new FieldError<BackendErrorWithMessage['errors']>(
          errors,
          message,
          status,
          response,
          headers,
          error,
        );
      }
      return error;
    }),
  );
};
